import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { ContainerScreenGeneral } from "../../../components";
import InteraccionesPersonal from "./Charts/InteraccionesPersonal";
import InteraccionesPorUsuario from "./Charts/InteraccionesPorUsuario";
import { useMonitoreoPersonalStore } from "../../../store/monitoreoPersonal";

const MonitoreoPersonal = () => {
  const [tabCurrent, setTabCurrent] = useState(1);
  const { type } = useMonitoreoPersonalStore();

  const handleTabs = (event, newValue) => {
    setTabCurrent(newValue);
  };


  return (
    <ContainerScreenGeneral size={"full"} linkBack={"/menu-admin"} titulo={"Monitoreo personal"}>
      {/* <Tabs
        value={tabCurrent}
        onChange={handleTabs}
        textColor="primary"
        indicatorColor="primary"
        aria-label="tabs monitoreo"
        variant="fullWidth"
        
      >
        <Tab value={1} label="General" />
        <Tab value={2} label="Por usuario" />
      </Tabs>

      {tabCurrent === 1 && <InteraccionesPersonal />}
      {tabCurrent === 2 && <InteraccionesPorUsuario />} */}
      {
        type == "general"
          ?
          <InteraccionesPersonal />
          : type == "personal"
            ?
            <InteraccionesPorUsuario />
            : null
      }
    </ContainerScreenGeneral>
  );
};

export default MonitoreoPersonal;
